/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import broadcast
import ResendEmail from '../views/resend-email/ResendEmail.vue';

import { setBreadcrumb } from './index';

const resendEmailRoute = {
  path: '/resend-email',
  meta: {
    title: 'BNI QRIS - Resend Email',
    appBarTitle: 'Resend Email',
  },
  component: Parent,
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Resend Email',
        appBarTitle: 'Resend Email',
        breadcrumbs: () => [
          setBreadcrumb('resend email', '/resend-email', true),
          setBreadcrumb('list merchant', '/resend-email', true),
        ],
      },
      component: ResendEmail,
    },
  ],
};
export default resendEmailRoute;
